export default JSON.parse(`{"devMode":false,"ejs":{},"enableWebp":false,"name":"kodak-nuxt","projectType":"nuxt2-craft"}`);